import { render, staticRenderFns } from "./ProductRelationshipLoad.vue?vue&type=template&id=67993526&scoped=true&"
import script from "./ProductRelationshipLoad.vue?vue&type=script&lang=js&"
export * from "./ProductRelationshipLoad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67993526",
  null
  
)

export default component.exports